import React, { ChangeEvent } from 'react';
import { StyledHeaderWrapper } from './styled';
import { tid } from '@utils/test';
import { Input } from 'antd';

const ModalTitleWithSearch = ({
  placeholder,
  modalTitle,
  searchText,
  setSearchText,
  searchRef,
}) => {
  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => setSearchText(e.target.value);

  const onSearch = (value: string) => {
    setSearchText(value.toLowerCase());
  };

  return (
    <StyledHeaderWrapper {...tid('header')}>
      {modalTitle}
      <Input.Search
        placeholder={placeholder}
        onSearch={onSearch}
        value={searchText}
        onChange={onChangeSearch}
        allowClear
        enterButton
        style={{ width: 250 }}
        ref={searchRef}
      />
    </StyledHeaderWrapper>
  );
};

export default ModalTitleWithSearch;
